/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CompanyGridItemViewModel } from "../types/CompanyGridItemViewModel.ts";

export const companyGridItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.string().nullish(),
  name: z.string().nullish(),
  url: z.string().nullish(),
  partnershipDateStart: z.string().datetime().nullish(),
  partnershipDateEnd: z.string().datetime().nullish(),
}) as unknown as ToZod<CompanyGridItemViewModel>;
